<template>
    <!-- TODO: sprawdzić dlaczego jak komponenty contentu niżej były wrapnięte w <div></div> to rzucało błedami
            po zmianie taba
    -->
    <div>
        <BasicTabs
            grow
            :model-value="currentTab"
        >
            <BasicTabHeader
                value="login"
                icon="avatar"
                data-testid="login-tab-auth-page"
            >
                {{ translations.login }}
            </BasicTabHeader>
            <BasicTabHeader
                value="register"
                icon="pen"
                data-testid="register-tab-auth-page"
            >
                {{ translations.register }}
            </BasicTabHeader>
            <!-- <div value="login">
                <LoginForm></LoginForm>
            </div> -->
            <LoginForm value="login"></LoginForm>
            <RegistrationForm value="register"></RegistrationForm>
        </BasicTabs>
    </div>
</template>

<script setup lang="ts">
import BasicTabHeader from '@molecules/BasicTabs/BasicTabHeader.vue';
import BasicTabs from '@molecules/BasicTabs/BasicTabs.vue';
import { useI18n } from '#imports';

const LoginForm = defineAsyncComponent(
    () => import('@organisms/LoginForm.vue')
);
const RegistrationForm = defineAsyncComponent(
    () => import('@organisms/RegistrationForm.vue')
);

const { query } = useRoute();
const currentTab = ref((query.tab as string) || 'login');

const { t } = useI18n();
const translations = computed(() => ({
    login: t('atp.components.login_and_register.tabs.login'),
    register: t('atp.components.login_and_register.tabs.register'),
}));
</script>
